import { church } from "./church";

/**
 * The church's photo, or without one, its brand colour turned a little round the hue, as its
 * icons are. A browser without relative colours gets the brand colour flat.
 */
export const churchBackdrop = () =>
    church.images.photo
        ? `url(${church.images.photo})`
        : "linear-gradient(135deg, oklch(var(--p)), oklch(from oklch(var(--p)) l c calc(h + 25)))";
